/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { ASSET_CONDITIONS } from 'domain/finance/assets/useAssetService';

const AssetConditionDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown placeholder="Select Condition" options={ASSET_CONDITIONS} {...props} />;
};

export default AssetConditionDropdown;
